// ABOUTME: The my-job route (/account/assignments/:assignmentId, the assignment's refId): the current state and the
// ABOUTME: contract changes, and with PJL the page of the job itself, as the job details draw it, with both on top.
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import { PageHeader } from 'components/PageHeader';
import { ErrorFallbackScreen } from 'components/screens';
import { AssignmentChangeLog } from 'modules/assignment-change-log';
import {
  AssignmentDetails,
  AssignmentDetailsContextProvider,
  AssignmentJobBadge
} from 'modules/assignment-details';
import { getTrans } from 'modules/i18n';
import {
  JobListingHeader,
  JobListingSections,
  JobListingSectionsSkeleton,
  useJobPage
} from 'modules/jobListings';
import { Layout } from 'modules/minimal-ui-theme';
import { FeatureFlag, useFeatureToggle } from 'modules/unleash';

/**
 * PJL: pro-core serves the job of my job (GET /talent/assignments/{assignmentRefId}/job) while PRO_JOB_LISTING and
 * PRO_APPLY_V2 are on. Then the page is the job's: its header, "Dein Job" with the current state, the contract changes
 * as their own section, and the job's sections. While the job loads, the state shows at once with a skeleton for the
 * job part; off, a 404 or a failed read leave the page as it was.
 */
export const AssignmentDetailsPage = () => {
  const { isEnabled: isAssignmentManagementEnabled, isLoading } =
    useFeatureToggle(FeatureFlag.PRO_TALENT_IS_ASSIGNMENT_MANAGEMENT_ENABLED);
  const { assignmentId } = useParams();
  const job = useJobPage(
    'assignment',
    isAssignmentManagementEnabled ? assignmentId : undefined
  );

  if (isLoading) return null;

  if (!isAssignmentManagementEnabled) {
    return <ErrorFallbackScreen />;
  }

  const isJobPage = job.state === 'ready';

  return (
    <AssignmentDetailsContextProvider>
      <Layout
        header={
          <PageHeader
            title={getTrans(
              isJobPage ? 'jobs.detail.title' : 'assignmentDetailsPage.title'
            )}
            withBackBtn
          />
        }
      >
        {job.state === 'ready' ? (
          <Box data-testid="assignment-job-page">
            <JobListingHeader
              listing={job.job}
              badges={<AssignmentJobBadge />}
            />
            <AssignmentDetails asJobSection job={job.job} />
            <AssignmentChangeLog asJobSection />
            <JobListingSections listing={job.job} />
          </Box>
        ) : (
          <Box>
            <AssignmentDetails />
            <AssignmentChangeLog />
            {job.state === 'loading' && <JobListingSectionsSkeleton />}
          </Box>
        )}
      </Layout>
    </AssignmentDetailsContextProvider>
  );
};
